import PageLogicalTest from './PageLogicalTest';



export default PageLogicalTest;
